import { components } from 'react-select'
import { CareTabs } from './data'
import { SearchIcon } from './icons'

export const menuListHoc =
  ({ selectedTab, selectOptions, onMore }: any) =>
  (props: any) => {
    const {
      children,
      className,
      cx,
      getStyles,
      innerProps,
      innerRef,
      isMulti
    } = props

    return (
      <div
        css={getStyles('menuList', props)}
        className={cx(
          {
            'menu-list': true,
            'menu-list--is-multi': isMulti
          },
          className
        )}
        ref={innerRef}
        {...innerProps}
      >
        <div
          style={{
            maxHeight: '55vh',
            overflowY: 'scroll'
          }}
        >
          {children}
        </div>
        {selectedTab !== CareTabs.ALL && selectOptions.length ? (
          <div
            onClick={onMore}
            className="text-center py-3 fs-18 text-info btn text-center w-100"
          >
            View More {selectedTab === 'provider' ? 'Providers' : 'Facilities'}
          </div>
        ) : null}
      </div>
    )
  }

// Keep this component outside to avoid focus loss of input when typing
export const ValueContainer = ({ children, ...props }: any) => {
  return (
    <components.ValueContainer {...props}>
      <SearchIcon style={{ position: 'absolute', left: -15 }} />
      {children}
    </components.ValueContainer>
  )
}
